import { ProjectCard } from "@components/atoms/ProjectFilter"
import { FooterHero } from "@components/atoms/FooterHero"
import { defineView } from "eddev/views"
import { ProjectFragment } from "../types.graphql"

export default defineView("taxonomy-project-category", (props) => {
  return (
    <div className="w-full h-full relative flex flex-col justify-between">
      <div>
        <h1 className="hidden md:block type-title-xxl-light w-full pt-5 pb-[100px]">
          {props.projectCategory?.name} projects
        </h1>
        <div className="oversize border-b hidden md:block" />

        <div className="grid-auto oversize">
          <div className="col-span-12 flex flex-col">
            {props.projectCategory?.projects?.nodes?.map((project: ProjectFragment, i: number) => (
              <ProjectCard project={project} key={i} />
            ))}
          </div>
        </div>
      </div>
      <FooterHero />
    </div>
  )
})
